import { ReactNode } from 'react';
import { Box, Typography, Paper } from '@mui/material';

interface EmptyStateProps {
  icon: ReactNode;
  message: string;
  subMessage?: string;
  dashed?: boolean;
}

/**
 * Centered empty-state placeholder with an icon, primary message, and optional sub-message.
 * Set `dashed` for a dashed-border Paper variant (e.g. document upload areas).
 */
export function EmptyState({ icon, message, subMessage, dashed = false }: EmptyStateProps) {
  if (dashed) {
    return (
      <Paper
        variant="outlined"
        sx={{
          p: 4,
          textAlign: 'center',
          bgcolor: 'background.default',
          borderRadius: 2,
          borderStyle: 'dashed',
        }}
      >
        <Box sx={{ opacity: 0.5, mb: 1 }}>{icon}</Box>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
        {subMessage && (
          <Typography variant="caption" color="text.secondary" display="block">
            {subMessage}
          </Typography>
        )}
      </Paper>
    );
  }

  return (
    <Box sx={{ padding: 3, textAlign: 'center' }}>
      {icon && <Box sx={{ opacity: 0.5, mb: 1 }}>{icon}</Box>}
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
      {subMessage && (
        <Typography variant="caption" color="text.secondary" display="block">
          {subMessage}
        </Typography>
      )}
    </Box>
  );
}
